import faker from 'faker';
import { Factory } from 'miragejs';

const LANGUAGES = ['es_ES', 'en_US'];

const account = Factory.extend({
  id: () => faker.datatype.uuid(),
  name: () => `${faker.name.firstName()} ${faker.name.lastName()}`,
  email: () => faker.internet.email(),
  office_phone: () => faker.phone.phoneNumber(),
  lang: () => faker.random.arrayElement(LANGUAGES),
  picture: () => faker.image.avatar(),
  requests_time_in_advance_minutes: () => 4320,
  appointment_request_duration_min: () => faker.datatype.number(),
  appointment_request_slot_interval_min: () => faker.datatype.number(),
  appointment_request_window_days: () => faker.datatype.number(),
  appointment_default_color: () => faker.datatype.number(),
  auto_reject_appointments: () => faker.datatype.boolean(),
  auto_accept_appointments: () => faker.datatype.boolean(),
  requests_auto_reject_minutes: () => faker.datatype.number(),
  default_provider_id: () => null,
  calendar_type: () => faker.datatype.number({ min: 0, max: 3 }),
  last_sync_time: () => faker.date.past(),
  username: () => faker.internet.userName(),
  user_is_staff: () => false,
  out_of_sync_scheduling_enabled: () => true,
  telemedicine_url: () => 'https://doxy.me/solerdemo',
  has_telemedicine: () => true,
  has_telemedicine_setup: () => true,
  company_industry: () => ({
    name: faker.random.arrayElement(['HEALTHCARE', 'BASE']),
  }),
  bot_can_failover_during_work_hours: () => faker.datatype.boolean(),
  timezone: () => 'America/Puerto_Rico',
  bot_numbers: () => [
    {
      id: faker.datatype.uuid(),
      number: faker.phone.phoneNumber(),
      phone_type: 1,
      outbound_sms_enabled: true,
      is_call_rescue_number: true,
    },
  ],
  stripe_customer_id: () => `cus_${faker.random.alphaNumeric(15)}`,
  bot_number_area_code: () => '787',
  features: () => {
    return {
      cancelations_enabled: faker.datatype.boolean(),
      confirmations_enabled: faker.datatype.boolean(),
      calendar_sync_enabled: faker.datatype.boolean(),
      is_waiting_list_enabled: faker.datatype.boolean(),
      confirmations_should_include_time: faker.datatype.boolean(),
      scheduling_enabled: faker.datatype.boolean(),
      sms_language_detection_enabled: faker.datatype.boolean(),
      has_active_subscription: faker.datatype.boolean(),
      text_back_enabled: faker.datatype.boolean(),
      voicemail_enabled: faker.datatype.boolean(),
      out_of_sync_scheduling_enabled: faker.datatype.boolean(),
      has_telemedicine: faker.datatype.boolean(),
      is_missed_call_open_thread: faker.datatype.boolean(),
      flags: {
        has_bot_numbers_enabled: true,
        has_business_profile_enabled: true,
        has_business_profile_responses_enabled: true,
        has_referral_form_enabled: true,
        has_practice_fusion_scheduling: true,
        has_waiting_list_preturns: true,
        has_entities_enabled: true,
        has_synced_patient_appointment_request: true,
      },
    };
  },
  call_rescue_tests_enabled: () => true,
  salesforce_id: () => null,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  afterCreate(
    acc: unknown,
    server: { createList: (arg0: string, arg1: number, arg2: { account: unknown }) => void }
  ): void {
    server.createList('user', 5, { account: acc });
    server.createList('businessPhone', 2, { account: acc });
    server.createList('billingSetting', 1, { account: acc });
  },
});

export default account;
